import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsIdentification = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M7.383 35.532C11.118 40.667 17.16 44.02 24 44.02s12.882-3.352 16.617-8.488zm33.234 0L24 3.286 7.383 35.532 24 8.867z" }) }) })
});
export default SvgMetricsIdentification;
